/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Portal appointment representation
 * @export
 * @interface AppointmentPortalResponse
 */
export interface AppointmentPortalResponse {
    /**
     * the unique identifier of the appointment
     * @type {string}
     * @memberof AppointmentPortalResponse
     */
    uuid?: string;
    /**
     * the unique identifier of the portal patient
     * @type {string}
     * @memberof AppointmentPortalResponse
     */
    patientUuid?: string;
    /**
     * the unique identifier of the doctor for the appointment
     * @type {string}
     * @memberof AppointmentPortalResponse
     */
    doctorUuid?: string;
    /**
     * the unique identifier of the institute from where the doctor will take the appointment
     * @type {string}
     * @memberof AppointmentPortalResponse
     */
    instituteUuid?: string;
    /**
     * the unique identifier of the appointment type
     * @type {string}
     * @memberof AppointmentPortalResponse
     */
    appointmentType?: string;
    /**
     * The appointment date time to reserve
     * @type {string}
     * @memberof AppointmentPortalResponse
     */
    appointmentDateTime?: string;
    /**
     * The comment from the patient to the doctor
     * @type {string}
     * @memberof AppointmentPortalResponse
     */
    comment?: string;
}

/**
 * Check if a given object implements the AppointmentPortalResponse interface.
 */
export function instanceOfAppointmentPortalResponse(value: object): value is AppointmentPortalResponse {
    return true;
}

export function AppointmentPortalResponseFromJSON(json: any): AppointmentPortalResponse {
    return AppointmentPortalResponseFromJSONTyped(json, false);
}

export function AppointmentPortalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentPortalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'patientUuid': json['patientUuid'] == null ? undefined : json['patientUuid'],
        'doctorUuid': json['doctorUuid'] == null ? undefined : json['doctorUuid'],
        'instituteUuid': json['instituteUuid'] == null ? undefined : json['instituteUuid'],
        'appointmentType': json['appointmentType'] == null ? undefined : json['appointmentType'],
        'appointmentDateTime': json['appointmentDateTime'] == null ? undefined : json['appointmentDateTime'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function AppointmentPortalResponseToJSON(json: any): AppointmentPortalResponse {
    return AppointmentPortalResponseToJSONTyped(json, false);
}

export function AppointmentPortalResponseToJSONTyped(value?: AppointmentPortalResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'patientUuid': value['patientUuid'],
        'doctorUuid': value['doctorUuid'],
        'instituteUuid': value['instituteUuid'],
        'appointmentType': value['appointmentType'],
        'appointmentDateTime': value['appointmentDateTime'],
        'comment': value['comment'],
    };
}

